module.exports = __webpack_public_path__ + "img/group1.08e7a4be.png";